
const faqsData= {

	title: "FAQs",
	description: [
		"Find answers to commonly asked questions about the Standard Bank Tutuwa Community Foundation below. If you can’t find an answer to your question here, please <a href='/contact'>contact us.</a>",
	],
		faqs: [
		{
			title: "What are the requirements for applying for funding?",
			answer: "Our Foundation does not accept unsolicited requests for funding.",
		},
		{
			title: "Is my organisation eligible to receive funding through the Foundation?",
			answer: "Our foundation partners with registered non-profit organisations working in our key focus areas. Initiatives need to align to our vision, mission and investment principles. Proposals are assessed and, if eligible, considered by the Programmes Committee and the Board of Directors for approval. We cannot guarantee a positive outcome, notwithstanding the merit of the proposal.",
		},
		{
			title: "Why does the Foundation focus on three particular areas?",
			answer: "We will invest our financial resources, time and expertise over the next decade to support the development of a strong, coherent and equitable education system that consistently delivers quality care, development and learning opportunities so that children can thrive, from their earliest years through to the end of their schooling journey and beyond the classroom.<br> We define a thriving learner as - Where hope is alive and children are achieving age-appropriate developmental, social and academic outcomes.",
		},
		{
			title: "In what geographic areas does the Foundation make grants?",
			answer: "Our Foundation funds initiatives across all nine provinces in South Africa.",
		},
		{
			title: "How can I reach the Foundation?",
			answer: "Please see the <a href='/contact'>contact us</a> page.",
		},
		{
			title: "Is the Foundation part of Standard Bank’s corporate social investment programme?",
			answer: "The Foundation is a separate legal entity, registered as a Non-Profit Company (NPC) and a Public Benefit Organisation (PBO) with the South African Revenue Service (SARS). The Foundation is a separate legal entity from Standard Bank of South Africa Limited and its Corporate Social Investment department. For more information on the bank’s CSI,  <a href='https://www.standardbank.com/sbg/standard-bank-group/why-we-matter/report-to-society' target='_blank'>click here</a>.",
		},
	]
};

export { faqsData };
